import IButtonGroup from '@inkline/inkline/src/components/IButtonGroup';
import ICheckableGroup from "@inkline/inkline/src/components/ICheckableGroup";

export default {
    name: 'ICheckboxButtonGroup',
    extends: ICheckableGroup,
    components: {
        IButtonGroup
    }
};
